import React, { useContext, useState } from "react";
import styled from "@emotion/styled";
import Context from "../ProductsProvider";
import { getSlug } from "../../../helpers/filters";
import ClearAllButton from "./ClearAllButton";

//style rules
import { Sizes, Colors, Typography } from "../../../styles";

const ActiveFilters = () => {
	const { data: { activeFilters, filterGroups, language },
		actions: { setActiveFilters, setParams },
	} = useContext(Context);

	const [activeFilter, setActiveFilter] = useState("");

	const handleClick = (filterTitle) => {
		setActiveFilter(filterTitle);

		//  remove the filter from the activeFilters array
		setActiveFilters((currentValue) => {
			const index = currentValue.indexOf(activeFilter);
			const activeFiltersCopy = [...currentValue];
			return activeFiltersCopy.toSpliced(index, 1);
		});
		
		// remove the filter from the params object
		setParams((currentValue) => {
			const searchParams = new URLSearchParams(currentValue.toString());
			const foundCategory = getSlug(filterTitle, filterGroups).groupSlug;
			const foundSlug = getSlug(filterTitle, filterGroups).filterSlug;
			const category = foundSlug !== "bdc" ? foundCategory : "supported";
			const slug = foundSlug !== "bdc" ? foundSlug : "true";
			searchParams.delete(category, slug);
			searchParams.set("pageNumber", 1);
			return searchParams;
		});
	}

	const clearBtnAriaLabel = () => {
		if (language === "en") return "clear filter";
		return "Effacer le filtre";
	}

	if (activeFilters.length === 0) return null;

	return (
		<ActiveFiltersList>
			{
				activeFilters.map( activeFilter => {
					if (!activeFilter) return null;

					return (
						<ActiveFilterItem key={activeFilter}>
							<ClearButton 
								type="button" 
								aria-label={clearBtnAriaLabel()}
								onClick={() => handleClick(activeFilter)}
							>
								<CloseIcon src={`${mainScript.assetPath}images/svg/icons/icon-close-teal.svg`}/>
							</ClearButton>
							{activeFilter}
						</ActiveFilterItem>
					)
				})
			}
			{
				// render clear all button when there are active filters
				activeFilters.length > 0 &&
			<ClearAllButton />
			}
		</ActiveFiltersList>
	)
}

export default ActiveFilters;

const ActiveFiltersList = styled.ul`
	list-style: none;
	padding: unset;
	margin: 1.5rem 0 0 0;
	display: flex;
	gap: 1rem 1rem;
	flex-wrap: wrap;

	@media only screen and (min-width: ${Sizes.screens.large}) {
		margin: 0;
	}
`;

const ActiveFilterItem = styled.li`
	margin: unset;
	padding: 0 1rem;
	border-radius: 2rem;
	background-color: ${Colors.fp.teal10};
	color: ${Colors.fp.teal};
	display: flex;
	align-items: center;
	justify-content: center;
	column-gap: 0.5rem;
	flex-wrap: nowrap;
	font-size: 1.1rem;
	font-weight: ${Typography.fontWeight.bold};
	letter-spacing: 0.01rem;
	text-transform: uppercase;
`;

const ClearButton = styled.button`
	all: unset;
	line-height: 1rem;
	cursor: pointer;

	&:hover,
	&:focus {
		@media only screen and (min-width: ${Sizes.screens.large}) {
			padding-right: 0;
	
			&::after {
				content: none;
			}
		}
	}
`;

const CloseIcon = styled.img`
`;
